import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface AbstractsStatusUpdateData {
    statusId: number;
}

export class AbstractsStatusUpdate implements FormValidationModel<AbstractsStatusUpdateData> {
    public data: AbstractsStatusUpdateData;
    public rules: yup.Schema<AbstractsStatusUpdateData>;

    public constructor() {
        this.data = {
            statusId: -2,
        };
        this.rules = yup.object<AbstractsStatusUpdateData>().shape({
            statusId: yup.number().required().label("Status").min(0, "Please select a valid status type."),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminAbstracts/AbstractsStatusUpdate.ts